<template>
  <MainLayout>
    
    <!-- Header -->
    <PageHeader 
      icon="ri-user-line"
      title="Mi Cuenta"
      subtitle="Revisa tu información personal"
      :show-button="false"
    />

    <div class="content-container">
      <!-- Información Personal -->
      <div class="profile-section">
        <div class="section-header">
          <i class="ri-user-line"></i>
          <h2>Información Personal</h2>
        </div>
        
        <div class="info-grid">
          <div class="info-item">
            <div class="info-icon">
              <i class="ri-user-line"></i>
            </div>
            <div class="info-content">
              <span class="info-label">Nombres</span>
              <span class="info-value">{{ user.data.primer_nombre }} {{ user.data.segundo_nombre }}</span>
            </div>
          </div>

          <div class="info-item">
            <div class="info-icon">
              <i class="ri-user-line"></i>
            </div>
            <div class="info-content">
              <span class="info-label">Apellidos</span>
              <span class="info-value">{{ user.data.primer_apellido }} {{ user.data.segundo_apellido }}</span>
            </div>
          </div>

          <div class="info-item">
            <div class="info-icon">
              <i class="ri-mail-line"></i>
            </div>
            <div class="info-content">
              <span class="info-label">Correo</span>
              <span class="info-value">{{ user.data.email }}</span>
            </div>
          </div>

          <div class="info-item">
            <div class="info-icon">
              <i class="ri-id-card-line"></i>
            </div>
            <div class="info-content">
              <span class="info-label">Documento</span>
              <span class="info-value">{{ user.data.numero_documento }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Información Académica -->
      <div v-if="cursoActual" class="profile-section">
        <div class="section-header">
          <i class="ri-graduation-cap-line"></i>
          <h2>Información Académica</h2>
        </div>
        
        <div class="info-grid">
          <div class="info-item">
            <div class="info-icon">
              <i class="ri-book-2-line"></i>
            </div>
            <div class="info-content">
              <span class="info-label">Módulo Actual</span>
              <span class="info-value">{{ cursoActual.nombre }}</span>
            </div>
          </div>

          <div v-if="user && user.data && user.data.vigencia" class="info-item">
            <div class="info-icon">
              <i class="ri-time-line"></i>
            </div>
            <div class="info-content">
              <span class="info-label">Vigencia</span>
              <span class="info-value">{{ user.data.vigencia }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Información de Sede -->
      <div v-if="sedes.length > 0 && sedeOriginal && sedeOriginal.nombre" class="profile-section">
        <div class="section-header">
          <i class="ri-map-pin-line"></i>
          <h2>Información de Sede</h2>
        </div>
        
        <div class="info-grid">
          <div class="info-item">
            <div class="info-icon">
              <i class="ri-home-4-line"></i>
            </div>
            <div class="info-content">
              <span class="info-label">Sede Original</span>
              <span class="info-value">{{ sedeOriginal.nombre }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Preferencias -->
      <div class="profile-section">
        <div class="section-header">
          <i class="ri-settings-3-line"></i>
          <h2>Preferencias</h2>
        </div>
        
        <div class="preferences-content">
          <div class="preference-item">
            <div class="preference-info">
              <i class="ri-notification-3-line"></i>
              <div class="preference-text">
                <strong>Notificaciones</strong>
                <p>{{ show_notification ? 'Activadas' : 'Desactivadas' }}</p>
              </div>
            </div>
            <button 
              :class="['btn-toggle', { 'active': show_notification }]"
              @click="setShowNotification(!show_notification)">
              <span class="toggle-slider"></span>
            </button>
          </div>
        </div>
      </div>
    </div>

  </MainLayout>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import MainLayout from './Layout/MainLayout.vue';
import PageHeader from './Layout/PageHeader.vue';

export default {
  name: 'perfil',

  components: {
    MainLayout,
    PageHeader
  },

  mounted() {
    if (!this.cursoActual) {
      this.fetchCursoActual()
    }
    if (!this.sedeActual) {
      this.fetchSedeActual()
    }
    if (!this.sedes || (this.sedes && this.sedes.length == 0)) {
      this.fetchSedes()
    }
  },
  methods: {
    ...mapActions({
      fetchSedes: 'sedes/fetchLista',
      fetchCursoActual: 'academico/fetchCursoActual',
      fetchSedeActual: 'academico/fetchSedeActual',
    }),
    ...mapMutations({
      setShowNotification: 'setShowNotification'
    }),


  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      sedeActual: state => state.academico.sedeActual,
      cursoActual: state => state.academico.cursoActual,
      show_notification: state => state.show_notification,
      sedes: state => state.sedes.lista,
    }),
    ...mapGetters({
      getSede: 'sedes/getSede',
    }),
    sedeOriginal() {
      return this.getSede(this.user.data.sede_original_id)
    },

  }

}
</script>

<style scoped>
.profile-modern {
  min-height: 100vh;
  background: var(--theme-gradient-bg);
  font-family: var(--app-font-family);
}

/* ============================================
   CONTENT CONTAINER
   ============================================ */
.content-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

/* ============================================
   PROFILE SECTIONS
   ============================================ */
.profile-section {
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: var(--theme-shadow-md);
  transition: all 0.3s ease;
}

.profile-section:hover {
  transform: translateY(-2px);
  box-shadow: var(--theme-shadow-lg);
}

.section-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid var(--theme-border-color);
}

.section-header svg {
  color: var(--app-primary-blue);
  flex-shrink: 0;
}

.section-header h2 {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--theme-text-primary);
  margin: 0;
}

/* ============================================
   INFO GRID
   ============================================ */
.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
  background: var(--theme-bg-tertiary);
  border: 1px solid var(--theme-border-color);
  border-radius: 8px;
  transition: all 0.2s ease;
}

.info-item:hover {
  background: var(--theme-hover-bg);
  border-color: var(--app-primary-blue);
}

.info-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, var(--app-primary-blue), #005a9e);
  color: white;
  border-radius: 8px;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(13, 78, 140, 0.3);
}

.info-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
  min-width: 0;
}

.info-label {
  font-size: 0.8125rem;
  color: var(--theme-text-secondary);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.info-value {
  font-size: 1rem;
  color: var(--theme-text-primary);
  font-weight: 600;
  line-height: 1.4;
  word-break: break-word;
}

/* ============================================
   PREFERENCES
   ============================================ */
.preferences-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.preference-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem;
  background: var(--theme-bg-tertiary);
  border: 1px solid var(--theme-border-color);
  border-radius: 8px;
  transition: all 0.2s ease;
}

.preference-item:hover {
  background: var(--theme-hover-bg);
}

.preference-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1;
}

.preference-info svg {
  color: var(--app-primary-blue);
  flex-shrink: 0;
}

.preference-text {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.preference-text strong {
  font-size: 1rem;
  color: var(--theme-text-primary);
  font-weight: 700;
}

.preference-text p {
  font-size: 0.875rem;
  color: var(--theme-text-secondary);
  margin: 0;
}

/* Toggle Button */
.btn-toggle {
  position: relative;
  width: 56px;
  height: 28px;
  background: var(--theme-border-color);
  border: none;
  border-radius: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  flex-shrink: 0;
}

.btn-toggle.active {
  background: linear-gradient(135deg, #10b981, #059669);
}

.toggle-slider {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 24px;
  height: 24px;
  background: white;
  border-radius: 50%;
  transition: transform 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.btn-toggle.active .toggle-slider {
  transform: translateX(28px);
}

.btn-toggle:hover {
  opacity: 0.9;
}

.btn-toggle:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(13, 78, 140, 0.2);
}

/* ============================================
   RESPONSIVE DESIGN
   ============================================ */
@media (max-width: 768px) {
  .content-container {
    padding: 1rem;
    gap: 1rem;
  }

  .profile-section {
    padding: 1.25rem;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .preference-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .btn-toggle {
    align-self: flex-start;
  }
}

@media (max-width: 480px) {
  .section-header h2 {
    font-size: 1.125rem;
  }

  .info-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .info-icon {
    width: 36px;
    height: 36px;
  }
}
</style>